import { useEffect } from 'react'
import { Routes, Route, useLocation } from 'react-router-dom'
import Navbar from './components/Navbar'
import Footer from './components/Footer'
import Loader from './components/Loader'
import Home from './pages/Home'
import Portfolio from './pages/Portfolio'
import Services from './pages/Services'
import ServiceDetail from './pages/ServiceDetail'
import Technologies from './pages/Technologies'
import About from './pages/About'
import Awards from './pages/Awards'
import Blog from './pages/Blog'
import PrivacyPolicy from './pages/PrivacyPolicy'
import TermsOfService from './pages/TermsOfService'
import RefundPolicy from './pages/RefundPolicy'
import Contact from './pages/Contact'
import PPCLanding from './pages/PPCLanding'
import IndustryPage from './pages/IndustryPage'
import Pricing from './pages/Pricing'
import Process from './pages/Process'
import StickyCTA from './components/StickyCTA'

import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default function App() {
  const { pathname } = useLocation()

  useEffect(() => {
    if ('scrollRestoration' in history) history.scrollRestoration = 'manual'
    window.scrollTo(0, 0)
    setTimeout(() => {
      window.scrollTo(0, 0)
      ScrollTrigger.refresh()
    }, 50)
  }, [pathname])

  return (
    <div className="min-h-screen bg-[#050505] text-white">
      <Loader />
      <Navbar />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/services" element={<Services />} />
          <Route path="/services/:id" element={<ServiceDetail />} />
          <Route path="/technologies" element={<Technologies />} />
          <Route path="/about" element={<About />} />
          <Route path="/awards" element={<Awards />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/contacts" element={<Contact />} />
          <Route path="/solutions/:slug" element={<PPCLanding />} />
          <Route path="/industries/:slug" element={<IndustryPage />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/process" element={<Process />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          <Route path="/refund-policy" element={<RefundPolicy />} />
        </Routes>
      </main>
      <Footer />
      <StickyCTA />

      <div className="grain-overlay" />
    </div>
  )
}
